<section class="tclass">

  <header class="tclass__head">
    <h3 class="tclass__title">
      <i class="fa-solid fa-calendar-day"></i>
      {{ 'DASHBOARD.TODAY_TITLE' | translate }}
      @if (liveCount()) {
        <span class="tclass__live-badge">
          <span class="tclass__pulse"></span>
          {{ 'CALENDAR.LIVE_NOW' | translate }}
        </span>
      }
    </h3>

    <!-- Trois lectures du même emploi du temps, chacune avec son effectif.
         Le compte est affiché même à zéro : « 0 en cours » est une réponse,
         une pastille absente est une question. -->
    <div class="tclass__tabs" role="tablist">
      <button type="button" role="tab" class="tclass__tab"
              [class.is-active]="activeTab() === 'today'"
              (click)="activeTab.set('today')">
        {{ 'DASHBOARD.TAB_TODAY' | translate }}
        <span class="tclass__count">{{ today().length }}</span>
      </button>
      <button type="button" role="tab" class="tclass__tab"
              [class.is-active]="activeTab() === 'live'"
              (click)="activeTab.set('live')">
        {{ 'DASHBOARD.TAB_LIVE' | translate }}
        <span class="tclass__count">{{ live().length }}</span>
      </button>
      <button type="button" role="tab" class="tclass__tab"
              [class.is-active]="activeTab() === 'upcoming'"
              (click)="activeTab.set('upcoming')">
        {{ 'DASHBOARD.TAB_UPCOMING' | translate }}
        <span class="tclass__count">{{ upcoming().length }}</span>
      </button>
    </div>
  </header>

  @if (errored) {
    <!-- Erreur de chargement : jamais de séances de substitution -->
    <app-error-state titleKey="DASHBOARD.ERROR_TITLE"
                     messageKey="DASHBOARD.ERROR_DESC"></app-error-state>
  } @else if (loading) {
    <div class="tclass__skeleton">
      @for (_ of [1, 2, 3]; track $index) {
        <div class="tclass__skeleton-row"></div>
      }
    </div>
  } @else if (visible().length === 0) {
    <div class="tclass__empty">
      <i class="fa-regular fa-calendar-check"></i>
      <p>
        @switch (activeTab()) {
          @case ('live')     { {{ 'DASHBOARD.NO_SESSION_LIVE' | translate }} }
          @case ('upcoming') { {{ 'DASHBOARD.NO_SESSION_UPCOMING' | translate }} }
          @default           { {{ 'DASHBOARD.NO_SESSION_TODAY' | translate }} }
        }
      </p>
    </div>
  } @else {
    <ul class="tclass__list">
      @for (s of visible(); track s.id) {
        <li class="tclass-item" [class]="view.colorClass(s)"
            [class.is-live]="isLive(s)" [class.is-done]="isDone(s)">
          <span class="tclass-item__time">
            <span class="tclass-item__hour">{{ time(s.startTime) }}</span>
            <span class="tclass-item__dur">{{ s.durationMinutes }}′</span>
          </span>

          <span class="tclass-item__body">
            <span class="tclass-item__title">
              {{ s.title }}
              @if (isLive(s)) {
                <span class="tclass-item__live">
                  <span class="tclass__pulse"></span>
                  {{ 'CALENDAR.LIVE_NOW' | translate }}
                </span>
              } @else if (isDone(s)) {
                <span class="tclass-item__done">{{ 'CALENDAR.ENDED' | translate }}</span>
              }
            </span>
            <span class="tclass-item__meta">
              <!-- Le mode se lit sur la ligne : il décrit la séance, il ne
                   justifie pas de couper la liste en deux. -->
              <span class="tclass-item__mode"
                    [class.is-online]="isOnline(s)">
                <i class="fa-solid" [class.fa-video]="isOnline(s)"
                   [class.fa-location-dot]="!isOnline(s)"></i>
                {{ (isOnline(s) ? 'CALENDAR.MODE_ONLINE' : 'CALENDAR.MODE_ONSITE') | translate }}
              </span>
              <i [class]="view.kindIcon(s.sessionKind)"></i>
              @if (view.subjectLabel(s)) { {{ view.subjectLabel(s) }} }
              @if (s.groupName) { · {{ s.groupName }} }
              @if (!s.groupName && s.consultantName) { · {{ s.consultantName }} }
              @if (s.location) { · {{ s.location }} }
            </span>
          </span>

          @if (s.meetingUrl && !isDone(s)) {
            <!-- Passe par l'API : l'accès est journalisé avant d'ouvrir la réunion -->
            <button type="button" class="tclass-item__join"
                    [class.is-live]="isLive(s)" (click)="join(s)">
              <i class="fa-solid fa-video"></i>
              {{ 'CALENDAR.JOIN' | translate }}
            </button>
          }
        </li>
      }
    </ul>
  }

  <a class="tclass__all" [routerLink]="calendarLink">
    {{ 'DASHBOARD.VIEW_ALL' | translate }}
    <i class="fa-solid fa-arrow-right"></i>
  </a>
</section>
